// extracted by mini-css-extract-plugin
export default {"p":"_67906347d8 d4d7b07923 d9b1e6a088","clr":"_0238e88d3c","dls":"_5023d04a87"};